export const maxLength = (value: string | undefined, maxLength: number) => {
    if (typeof value?.length === 'number' && value.length > maxLength) {
        return `Максимальное количество символов ${maxLength}`;
    }
    return '';
};
